/*
  - This includes functions to change user service like login and sign in using events
  - Commented by Sarthak on Feb 26, 2024
*/
import { Injectable, Output, EventEmitter } from "@angular/core";
import { Observable, of } from "rxjs";
import { Router } from "@angular/router";
import { BackendApiService } from "../services/backend-api.service";

@Injectable({
  providedIn: "root",
})
  /*
    - getLoggedInStatus and getLoaderStatus are function which are called from other files
    - Commented by Sarthak on Feb 26, 2024 
  */
export class ChangeUsersService {
  @Output() getLoggedInStatus: EventEmitter<any> = new EventEmitter();
  @Output() getLoaderStatus: EventEmitter<any> = new EventEmitter();

  constructor(public router: Router, public service: BackendApiService) {}
  /*
    - Depending upon loggedInStatus event is emitted 
    - Commented by Sarthak on Feb 26, 2024
  */
  login(status: string): Observable<boolean> {
    if (status) {
      this.getLoggedInStatus.emit("Log In");
      return of(true);
    } else {
      this.getLoggedInStatus.emit("Sign In");
      return of(false);
    }
  }

  autoCheckout() {
    // this.service.getCheckoutTime().then((res) => {
    //   const self = this;
    //   const EXPIRE_TIME = 1000 * 60 * 60 * JSON.parse(JSON.stringify(res)).checkoutTime;
    //   const timer = setTimeout(function () {
    //     localStorage.clear();
    //     self.router.navigate(["login"]);
    //     clearTimeout(timer);
    //   }, EXPIRE_TIME);
    // }).catch((error) => {
    //   console.log(error);
    // })
  }

    /*
    - Logout the user
    - Commented by Sarthak on Feb 26, 2024
  */
  logout(): void {
    this.getLoggedInStatus.emit("Sign In");
    this.router.navigate(['/login']);
  }
  /*
    - This sets the loader shown on screen to display loading animation
    - Commented by Sarthak on Feb 26, 2024
  */
  loader(status: boolean): Observable<boolean> {
    if (status) {
      this.getLoaderStatus.emit(true);
      return of(true);
    } else {
      this.getLoaderStatus.emit(false);
      return of(false);
    }
  }
}
